import { createSlice } from "@reduxjs/toolkit";
import type { PayloadAction } from "@reduxjs/toolkit";

const initialMainColoursState: any = {
  selected: {
    key: "Primary 1",
    colour: "#0A2C37",
    isPickerActive: false,
  },
  colours: [
    {
      key: "Primary 1",
      colour: "#0A2C37",
    },
    {
      key: "Primary 2",
      colour: "#0028D7",
    },
    {
      key: "Accent 3",
      colour: "#8ECBD2",
    },
    {
      key: "Accent 4",
      colour: "#E7ED95",
    },
  ],
};

export const mainColoursSlice = createSlice({
  name: "mainColors",
  initialState: initialMainColoursState,
  reducers: {
    editMainColours(
      state,
      action: PayloadAction<{ key: string; colour: string }>
    ) {
      const newColoursState = state.colours.map(
        (colour: { key: string; colour: string }) => {
          if (colour.key === action.payload.key) {
            return action.payload;
          } else {
            return colour;
          }
        }
      );
      state.colours = newColoursState;
      localStorage.setItem(
        "Colourama - Prev Colours",
        JSON.stringify({ colours: state.colours })
      );
    },
    setSelected(
      state,
      action: PayloadAction<{
        key: string;
        colour: string;
        isPickerActive?: boolean;
      }>
    ) {
      state.selected = action.payload;
      state.selected.isPickerActive = true;
    },
    setColorPickerState(state, action: PayloadAction<boolean>) {
      state.selected.isPickerActive = action.payload;
    },
    addMainColours(state, action: PayloadAction<string>) {
      let number = state.colours[state.colours.length - 1].key
      number = number.split(" ")[1]
      state.colours.push({
        key: `Accent ${Number(number) + 1}`,
        colour: action.payload,
      });
    },
    setMainColours(state, action: PayloadAction<any>) {
      state.colours = action.payload;
      state.selected = { ...action.payload[0], isPickerActive: false };
    },
    removeMainColour(state, action: PayloadAction<void>) {
      const newState = state.colours.filter(
        (colour: { key: string; colour: string }) => {
          return colour.key !== state.selected.key;
        }
      );
      state.colours = newState;
    },
  },
});

// Action creators are generated for each case reducer function
export const {
  editMainColours,
  setSelected,
  setColorPickerState,
  addMainColours,
  removeMainColour,
  setMainColours,
} = mainColoursSlice.actions;

export default mainColoursSlice.reducer;
